import { render, staticRenderFns } from "./Patches.vue?vue&type=template&id=23e5467e"
import script from "./Patches.vue?vue&type=script&lang=js"
export * from "./Patches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports